import cn from 'classnames'
import { FC, useMemo } from 'react'

import { Translation } from 'cng-common/features/translations'

import styles from './CockpitPlanQuality.module.scss'

interface ICockpitPlanQualityProps {
  titleKey?: string
  quality: number
  titleTranslationKey?: string
}

export const CockpitPlanQuality: FC<ICockpitPlanQualityProps> = ({
  titleKey,
  quality,
  titleTranslationKey,
}) => {
  const showTextSection = useMemo(() => Boolean(titleTranslationKey), [titleTranslationKey])

  const qualityLevel = useMemo(() => {
    if (quality <= 50) {
      return 'low'
    }

    if (quality <= 80) {
      return 'moderate'
    }

    if (quality > 80) {
      return 'high'
    }

    return null
  }, [quality])

  return (
    <div className={styles.root}>
      <div className={styles.circleWrapper}>
        {titleKey && (
          <div className={styles.title}>
            <Translation text={titleKey} />
          </div>
        )}
        <div
          className={cn(styles.circle, {
            [styles.low]: quality <= 50,
            [styles.moderate]: quality > 50 && quality <= 80,
            [styles.high]: quality > 80,
          })}
        >
          {quality}
        </div>
      </div>
      {showTextSection && (
        <div className={styles.textSection}>
          {titleTranslationKey && <Translation text={titleTranslationKey} />}
          {qualityLevel && <div className={styles.qualityLevel}>{qualityLevel}</div>}
        </div>
      )}
    </div>
  )
}
